import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";
import { useFlowStart } from "~/hooks/use-flow-start";

export const Route = createFileRoute("/(authenticated)/laadpaal-fotos-uploaden")({
  component: UploadChargerPhotosLayout,
});

function UploadChargerPhotosLayout() {
  useFlowStart("laadpaal_fotos_upload");

  return (
    <StepFlowLayout currentStep={1} totalSteps={1}>
      <Outlet />
    </StepFlowLayout>
  );
}
